<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title text-lg">{{ title }}</h4>
          </div>
        </md-card-header>

        <md-card-content v-if="dataDetail.length">
          <p class="font-medium text-xl mb-4">
            {{
              type === "SMI"
                ? $t("smi_sri.math_inventory_assessment")
                : $t("smi_sri.reading_comprehension_assessment")
            }}
            ({{ type }})
          </p>
          <div class="mb-10">
            <sri-smi-chart
              :chart-data-assessment="dataDetail"
              :type="type"
            ></sri-smi-chart>
          </div>
          <div class="md-layout">
            <div class="md-layout-item md-size-70 md-small-size-100">
              <table-proficiency-ranges :type="type"></table-proficiency-ranges>
            </div>
            <div
              class="md-layout-item md-size-30 md-small-size-100 text-center font-medium"
            >
              <p class="mb-3">BR = {{ $t("smi_sri.beginning_reader") }}</p>
              <div class="flex justify-center">
                <div class="square mr-3"></div>
                {{ $t("smi_sri.proficient") }}
              </div>
            </div>
          </div>

          <h6 class="title text-md font-medium normal-case my-5">
            {{ $t("smi_sri.total_tests_taken", { length: dataDetail.length }) }}
          </h6>
          <yv-table
            :tableData="tablePagination"
            :hideAction="true"
            :pagination="pagination"
            :columns="type === 'SRI' ? columnsSRI : columnsSMI"
            :clientSort="true"
            :hideBulkAction="true"
            :sortable="sortable"
            :sort-data="sortData"
          >
          </yv-table>
          <div
            class="text-center"
            v-show="buttonViewMore && dataDetail.length > 10"
          >
            <md-button
              class="md-simple md-just-icon md-icon-button md-info"
              @click="viewMore()"
            >
              <md-tooltip md-direction="top">
                {{ $t("smi_sri.view_more") }}
              </md-tooltip>
              <md-icon>arrow_downward</md-icon>
            </md-button>
          </div>
        </md-card-content>
        <md-card-content v-else>
          <no-data-found></no-data-found>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import YvTable from "@/components/Base/YvTable";
import SriSmiChart from "./SriSmiChart";
import TableProficiencyRanges from "@/components/TableProficiencyRanges";

export default {
  name: "assessment-detail",
  props: ["dataDetail", "title", "type"],
  components: { TableProficiencyRanges, SriSmiChart, YvTable },
  data() {
    return {
      pagination: {
        hidePerPageOptions: true
      },
      columnsSRI: {
        grade: "common.grade",
        date: "smi_sri.test_date",
        lexile_scores: "smi_sri.lexile_scores",
        total_time_per_test: "smi_sri.total_time_per_test"
      },
      columnsSMI: {
        grade: "common.grade",
        date: "smi_sri.test_date",
        quantile_scores: "smi_sri.quantile_scores",
        performance_level: "smi_sri.performance_level"
      },
      sortable: ["date"],
      sortData: {
        currentSortOrder: "desc"
      },
      tablePagination: [],
      buttonViewMore: true
    };
  },
  created() {
    this.tablePagination = this.dataDetail.slice(0, 10);
  },
  methods: {
    viewMore() {
      this.buttonViewMore = false;
      this.tablePagination = this.dataDetail;
    }
  }
};
</script>
<style lang="scss" scoped>
.square {
  height: 30px;
  width: 30px;
  background-color: #b0d58d;
}
</style>
